export const config = {
    documentDate: {
        label: "Дата документа",
        inputProps: { name: "documentDate", type: "date" },
        inPortal: true,
    },
    vatRate: {
        label: "Ставка НДС",
        type: "number",
        inputProps: { name: "vatRate", step: "0.01" },
    },
    total: {
        label: "Сумма",
        type: "number",
        inputProps: { name: "total", step: "0.01" },
    },
    comment: {
        label: "Комментарий",
        inputProps: { name: "comment" },
        textarea: true,
    },
};
